import {
  SET_THEME,
  SET_LOGO,
  SET_CLIENT_IDS,
  SET_LINKS,
  SET_ANALYTICS,
  GET_THEME,
  GET_LOGO,
  GET_CLIENT_IDS,
  GET_LINKS,
  GET_ANALYTICS,
} from "@/store/actions/theme";
import { SET_CURRENT_FEATURE_LICENCE } from "@/store/actions/licences";
import themes from "@/utils/themes";
import Vuetify from "@/plugins/vuetify";

export const getDefaultState = () => ({
  theme: themes.defaultTheme,
  logo: themes.defaultLogo,
  clientIDs: themes.defaultClientIDs,
  links: themes.defaultLinks,
  analytics: themes.defaultAnalytics,
});
const state = getDefaultState();

const getters = {
  getTheme: (state) => state.theme,
  getBrandID: (state) => state.theme.id,
  getLogo: (state) => state.logo,
  getClientIDs: (state) => state.clientIDs,
  getLinks: (state) => state.links,
  getAnalytics: (state) => state.analytics,
};

const actions = {
  [GET_THEME]: ({ commit, dispatch }, value) => {
    const setTheme = (event = {}) => {
      const theme =
        Object.keys(event).length !== 0 ? event : themes.defaultTheme;

      Vuetify.framework.theme.themes.dark = theme.dark;
      Vuetify.framework.theme.themes.light = theme.light;
      Vuetify.framework.theme.themes.name = theme.name;

      const root = document.documentElement;
      root.style.setProperty("--primary", theme.colorVariables.primary);
      root.style.setProperty("--secondary", theme.colorVariables.secondary);
      root.style.setProperty(
        "--navigation-bar-background-color",
        theme.colorVariables.navigationBarBackgroundColor
      );
      root.style.setProperty(
        "--navigation-bar-color",
        theme.colorVariables.navigationBarColor
      );

      window.document.title = theme.title;
      const favicon = document.getElementById("favicon");
      favicon.href = require(`@/assets/${theme.path}/favicon-32x32.png`);
      commit(SET_THEME, theme);
      commit(SET_CURRENT_FEATURE_LICENCE, {
        brandID: theme.id,
      });
    };

    const themeExists = themes.theme.find((element) => {
      return element.hostnames.includes(window.location.hostname);
    });

    typeof themeExists === "undefined" ? setTheme() : setTheme(themeExists);
  },
  [GET_LOGO]: ({ commit, dispatch }, value) => {
    const setLogo = (event = {}) => {
      const logo = Object.keys(event).length !== 0 ? event : themes.defaultLogo;
      commit(SET_LOGO, logo);
    };

    const logoExists = themes.logo.find((element) => {
      return element.hostnames.includes(window.location.hostname);
    });

    typeof logoExists === "undefined" ? setLogo() : setLogo(logoExists);
  },
  [GET_CLIENT_IDS]: ({ commit, dispatch }, value) => {
    const setClientIDs = (event = {}) => {
      const clientIDs =
        Object.keys(event).length !== 0 ? event : themes.defaultClientIDs;
      commit(SET_CLIENT_IDS, clientIDs);
    };

    const clientIdExists = themes.clientIDs.find((element) => {
      return element.hostnames.includes(window.location.hostname);
    });

    typeof clientIdExists === "undefined"
      ? setClientIDs()
      : setClientIDs(clientIdExists);
  },
  [GET_LINKS]: ({ commit, dispatch }, value) => {
    const setLinks = (event = {}) => {
      const links =
        Object.keys(event).length !== 0 ? event : themes.defaultLinks;
      state.links = links;
      commit(SET_LINKS, links);
    };

    const linkExists = themes.links.find((element) => {
      return element.hostnames.includes(window.location.hostname);
    });

    typeof linkExists === "undefined" ? setLinks() : setLinks(linkExists);
  },
  [GET_ANALYTICS]: ({ commit, dispatch }, value) => {
    const setAnalytics = (event = {}) => {
      const analytics =
        Object.keys(event).length !== 0 ? event : themes.defaultAnalytics;
      state.analytics = analytics;
      commit(SET_ANALYTICS, analytics);
      return analytics;
    };
    const analyticsExists = themes.analyticsConfig.find((element) => {
      return element.hostnames.includes(window.location.hostname);
    });
    const analytics =
      typeof analyticsExists === "undefined"
        ? setAnalytics()
        : setAnalytics(analyticsExists);

    //NOTE: Return promise here to fetch the analytics config before the getters is set
    return new Promise((resolve, reject) => {
      resolve(analytics);
    });
  },
};

const mutations = {
  [SET_THEME]: (state, value) => {
    state.theme = value;
  },
  [SET_LOGO]: (state, value) => {
    state.logo = value;
  },
  [SET_CLIENT_IDS]: (state, value) => {
    state.clientIDs = value;
  },
  [SET_LINKS]: (state, value) => {
    state.links = value;
  },
  [SET_ANALYTICS]: (state, value) => {
    state.analytics = value;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
